<template>
	<div id="legal">
		<!-- eslint-disable-next-line vue/no-v-html -->
		<div class="inner" v-html="ppDetail"></div>
	</div>
</template>

<script>
export default {
	name: 'PrivacyPolicy',
	data() {
		return {
			ppDetail: [],
		};
	},
	created() {
		this.$http.get(`${this.cdnHost}/frontend/v2/${environment.region}/pp/${this.$i18n.locale}.json`).then((response) => {
			this.ppDetail = response.data;
		});
	},
};
</script>
